import { Injectable } from '@angular/core';
import { Location2Store } from 'stores/location2.store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderMenuItemPinningStore {
  constructor(private location2Store: Location2Store) {}

  readonly isPinningEnabled$: Observable<boolean> =
    this.location2Store.currentLocation$.pipe(
      map(
        (location) => location.menuItemPinningEnabled && location.menuReadOnly
      )
    );

  private readonly _pinnedMenuItemIds$ = new BehaviorSubject(new Set<string>());

  setPinnedMenuItemIds(itemIds: string[]) {
    this._pinnedMenuItemIds$.next(new Set(itemIds));
  }

  readonly pinnedMenuItemIds$ = this._pinnedMenuItemIds$.pipe(
    map((idSet) => Array.from(idSet))
  );

  togglePinMenuItem(itemId: string) {
    const pinnedItemIds = this._pinnedMenuItemIds$.getValue();
    if (pinnedItemIds.has(itemId)) {
      pinnedItemIds.delete(itemId);
    } else {
      pinnedItemIds.add(itemId);
    }
    this._pinnedMenuItemIds$.next(pinnedItemIds);
  }

  unpinMenuItem(itemId: string) {
    const pinnedItemIds = this._pinnedMenuItemIds$.getValue();
    pinnedItemIds.delete(itemId);
    this._pinnedMenuItemIds$.next(pinnedItemIds);
  }

  unpinAllMenuItems() {
    this._pinnedMenuItemIds$.next(new Set<string>());
  }

  readonly shouldShowPinningFab$: Observable<boolean> = combineLatest([
    this.isPinningEnabled$,
    this.pinnedMenuItemIds$
  ]).pipe(
    map(
      ([isPinningEnabled, pinnedMenuItemIds]) =>
        isPinningEnabled && pinnedMenuItemIds.length > 0
    )
  );
}
